import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchICTData } from "../../../store/uiSlice";
import { useNavigate } from "react-router-dom";

const CoursesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ictData = [], loading, error } = useSelector((state) => state.ui);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(fetchICTData());
  }, [dispatch]);

  // filter by name or id
  const filtered = ictData.filter((c) => {
    const q = searchTerm.toLowerCase();
    return (
      c.ictName.toLowerCase().includes(q) ||
      String(c.id).includes(q)
    );
  });

  if (loading) return <p className="courses-loading">Loading courses…</p>;
  if (error) return <p className="courses-error">Error: {error}</p>;

  return (
    <div className="courses-container">
      <h2 className="courses-header">
        List of ICTs (Name & Id)
        <input
          type="text"
          className="filter-input"
          placeholder="Search by name or ID…"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </h2>
      <h6>Click on a course to view its catalog</h6>
      <ul className="courses-list">
        {filtered.map((course, index) => (
          <li
            key={course.id}
            className="courses-item"
            onClick={() => navigate(`/ict-catalog/${course.id}`)}
          >
            {index + 1})   {course.ictName} - {course.id}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CoursesList;
